module.exports = __webpack_public_path__ + "05c455ffa822f91707f63d95849630d5.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/DieAbfahrer.png
// module id = 955
// module chunks = 0